<template>
  <div class="modal">
    <div class="modal-container">
      <div class="modal-close">
        <CloseIcon @click="$emit('close')" />
      </div>
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
import CloseIcon from '@/assets/icons/close.svg';

export default {
  components: {
    CloseIcon,
  },
};
</script>
<style lang="scss" scoped>
.modal {
  @apply flex justify-center items-center fixed;
  z-index: 99999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  transition: opacity 0.3s ease;
  overflow-y: initial !important;
}

.modal-close {
  @apply absolute cursor-pointer;
  right: 20px;
  top: 25px;
}

.modal-container {
  @apply relative bg-white mx-auto px-8 pt-20 pb-12;
  overflow-y: auto;
  max-height: 100vh;
  max-width: 700px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  overflow-y: scroll;
  transition: all 0.3s ease;
  @screen md {
    max-height: 90vh;
    border-radius: 6px;
  }
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
